import React from 'react';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import BaseSection from '../BaseSection';
import nft from '../../Utils/Nft';
import * as AppActions from '../../AppActions';
import * as ErrorHandler from '../Error';
import {MenuAltRight} from '@styled-icons/boxicons-regular/MenuAltRight';

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function Navbar(props) {
  const {hideButtons = false} = props;
  const [updateCnt, setUpdateCnt] = useOutlet('update-counter');
  const [mobileMenuVisible, setMobileMenuVisible] = React.useState(false);
  const [dimension] = useOutlet('dimension');
  const [hover, setHover] = React.useState({});

  const forceUpdate = React.useCallback(async () => {
    setUpdateCnt((cnt) => cnt + 1);
  }, [setUpdateCnt]);

  async function onConnectClick() {
    if (ErrorHandler.handleGlobalError()) {
      return;
    }

    AppActions.setLoading(true);
    await delay(500);
    try {
      await nft.connect();
      // show user address earlier
      setUpdateCnt((cnt) => cnt + 1);
      forceUpdate();
    } catch (ex) {
      console.warn(ex);
    }
    AppActions.setLoading(false);
  }

  const navItems = [
    ['ABOUT', '/#'],
    ['GOVERNANCE', '/#'],

    ['PROPOSALS', '/#'],
    ['DISCUSSION', '/#'],
  ];

  return (
    <Header>
      <div className="content">
        <div onClick={() => AppActions.navigate('/')} style={{}}>
          <img
            src="/images/foxfairy/fox-logo.png"
            style={{width: '40%', minWidth: 200, maxWidth: 450}}
          />
        </div>
        <div style={{flex: 1}} />

        {!hideButtons && dimension.rwd === 'desktop' && (
          <>
            {navItems.map((n) => {
              return (
                <>
                  <a
                    href={n[1]}
                    key={n[0]}
                    className="link-item"
                    alt="link-item"
                    onMouseEnter={() => setHover({...hover, ['nav' + n]: true})}
                    onMouseLeave={() =>
                      setHover({...hover, ['nav' + n]: false})
                    }
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      position: 'relative',
                    }}>
                    {n[0]}
                    {hover['nav' + n] && (
                      <div
                        id={n[2]}
                        style={{
                          position: 'absolute',
                          backgroundColor: '#FDD36A',
                          color: 'white',
                          padding: 5,
                          borderRadius: 5,
                          top: 40,
                          left: -35,
                          width: 150,
                          textAlign: 'center',
                        }}>
                        It's not yet available
                      </div>
                    )}
                  </a>
                </>
              );
            })}
          </>
        )}

        <div
          style={{
            borderRadius: '50%',
            cursor: 'pointer',
          }}
          onClick={() =>
            window &&
            window.open('https://twitter.com/FoxFairyProject', '_blank')
          }>
          <img src="/images/foxfairy/twitter.png" style={{width: 32}} />
        </div>
        <>
          <div
            style={{
              borderRadius: '50%',
              cursor: 'pointer',
              position: 'relative',
            }}
            /*
            onMouseEnter={() => setHover({...hover, ['nav' + 'discord']: true})}
            onMouseLeave={() =>
              setHover({...hover, ['nav' + 'discord']: false})
            }
            */
            onClick={
              () =>
                window &&
                window.open('https://discord.gg/foxfairyfrojecnft', '_blank')
              /*
              dimension.rwd !== 'desktop'
                ? window.alert("It's not yet available")
                : 0
                */
            }>
            <img
              src="/images/foxfairy/discord.jpeg"
              style={{width: 32, marginLeft: 5, borderRadius: '50%'}}
            />
            {hover['nav' + 'discord'] && (
              <div
                style={{
                  position: 'absolute',
                  backgroundColor: '#FDD36A',
                  color: 'white',
                  padding: 5,
                  borderRadius: 5,
                  top: 40,
                  left: -35,
                  width: 150,
                  textAlign: 'center',
                }}>
                It's not yet available
              </div>
            )}
          </div>
        </>
        <div
          style={{
            borderRadius: '50%',
            cursor: 'pointer',
            marginLeft: 5,
          }}
          onClick={() =>
            window &&
            window.open(
              'https://opensea.io/collection/foxfairyproject-2',
              '_blank',
            )
          }>
          <img src="/images/foxfairy/opensea.png" style={{width: 32}} />
        </div>

        {dimension.rwd !== 'desktop' && (
          <MenuAltRight
            className="mobile-menu-btn"
            size={32}
            color="grey"
            onClick={() => setMobileMenuVisible(true)}
            style={{marginLeft: 15}}
          />
        )}
      </div>

      <MobileBackdrop
        visible={mobileMenuVisible}
        onClick={() => setMobileMenuVisible(false)}
      />

      {mobileMenuVisible && (
        <MobileMenu visible={mobileMenuVisible}>
          {navItems.map((item, idx) => (
            <>
              <a
                href={item[1]}
                className="link-item"
                alt="link-item"
                onClick={() => {
                  setMobileMenuVisible(false);
                  window.alert("It's not yet available");
                }}
                key={idx}>
                {item[0]}
              </a>
            </>
          ))}
        </MobileMenu>
      )}
    </Header>
  );
}

const Header = styled(BaseSection)`
  background-color: #a1ede0;
  & > .content {
    height: 72px;

    align-items: center;

    & > h2 {
      color: white;
      font-size: 2.5rem;
      cursor: pointer;
    }

    & > .link-item {
      color: grey;
      font-size: 1rem;
      margin: 0 20px;
    }
  }

  @media (max-width: 720px) {
    & .content {
      flex-direction: row;
      align-items: center;

      & > .link-item {
        display: none;
      }
    }
  }
`;
const MobileBackdrop = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: ${(props) =>
    props.visible ? 'rgba(0, 0, 0, 0.7)' : 'transparent'};
  pointer-events: ${(props) => (props.visible ? 'normal' : 'none')};
  z-index: 10;
  transition: all 200ms;
`;
const MobileMenu = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 300px;
  background-color: white;
  padding: 24px;
  z-index: 11;
  transform: ${(props) =>
    props.visible ? 'translateX(0)' : 'translateX(-250px)'};
  transition: all 200ms;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  & .link-item {
    font-size: 2rem;
    margin: 20 0px;
    color: grey;
  }
`;
export default Navbar;
